import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';

import {
    PAGE_TYPE,
    PageType,
    PROMOCODE_FORM_TYPE,
    PromocodeDTO,
} from '../service/promocodes.interface';
import {
    useCreatePromocodeMutation,
    useUpdatePromocodeMutation,
} from '../service/promocode.api';
import { useAppSelector } from '../../../../../store';
import { selectPromocode } from '../store/promocode.slice';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const usePromocodeForm = ({ type }: { type: PageType }) => {
    const navigate = useNavigate();
    const { formType } = useAppSelector(selectPromocode);
    const current = useAppSelector(selectShopCurrent);

    const [createPromocode, createState] = useCreatePromocodeMutation();
    const [updatePromocode, updateState] = useUpdatePromocodeMutation();

    const onSubmit = async (values: PromocodeDTO) => {
        const dateFormat = 'YYYY-MM-DD';
        const payload = {
            ...values,
            disable_usage_limit: !values.disable_usage_limit,
            shop_id: current.id,
            end_date: values.is_active
                ? dayjs(values.end_date).format(dateFormat)
                : dayjs().add(10, 'year').format(dateFormat),
        };

        const { code, ...rest } = payload;

        const finalPayload =
            formType === PROMOCODE_FORM_TYPE.GENERATED ? rest : payload;

        const action =
            type === PAGE_TYPE.EDIT ? updatePromocode : createPromocode;
        await action(finalPayload).then(() => navigate(-1));
    };

    return {
        onSubmit,
        isLoading: createState.isLoading || updateState.isLoading,
    };
};
